import { render, staticRenderFns } from "./radio.vue?vue&type=template&id=1480acf6&"
import script from "../descriptors/radio.js?vue&type=script&lang=js&"
export * from "../descriptors/radio.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports